import { render, staticRenderFns } from "./TagsExtracted.vue?vue&type=template&id=5094dc1e&scoped=true"
import script from "./TagsExtracted.vue?vue&type=script&lang=js"
export * from "./TagsExtracted.vue?vue&type=script&lang=js"
import style0 from "./TagsExtracted.vue?vue&type=style&index=0&id=5094dc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094dc1e",
  null
  
)

export default component.exports